"use strict";
/*
 * Created on 29.01.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * @author Tomáš Leity
 */


var ReplePromoManagementDetailFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(ReplePromoManagementDetailFilter, _AbstractEntityFilter);

  /**
   * @param windowItemIds
   * @param categoryIds
   * @param supplierIds
   * @param productIds
   */
  function ReplePromoManagementDetailFilter(windowItemIds, categoryIds, supplierIds, productIds) {
    var _this;

    _classCallCheck(this, ReplePromoManagementDetailFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplePromoManagementDetailFilter).call(this));
    _this.windowItemIds = windowItemIds;
    _this.categoryIds = categoryIds;
    _this.supplierIds = supplierIds;
    _this.productIds = productIds;
    return _this;
  }

  return ReplePromoManagementDetailFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.ReplePromoManagementDetailFilter = ReplePromoManagementDetailFilter;
ReplePromoManagementDetailFilter.EMPTY = new ReplePromoManagementDetailFilter();
/**
 * Pagination limit number
 */

ReplePromoManagementDetailFilter.PAGINATION_LIMIT = 1000;

ReplePromoManagementDetailFilter.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReplePromoManagementDetailFilter.name);
  return {
    windowItemIds: builder.opt(builder.listOf(builder.id('windowItemIds'))),
    categoryIds: builder.opt(builder.listOf(builder.id('categoryIds'))),
    supplierIds: builder.opt(builder.listOf(builder.id('supplierIds'))),
    productIds: builder.opt(builder.listOf(builder.id('productIds'))),
    limit: builder.opt(builder.num('limit')),
    offset: builder.opt(builder.num('offset'))
  };
}();